module.exports = __webpack_public_path__ + "assets/media/swallow_water_origin.ba64f4d8.mp4";